import { AfriexUserState } from '../domain/types/SecurityTypes.js';
export function deriveUserStateFromFlags(flags) {
    if (flags.isDeactivated || flags.isSecurityFlagged || flags.isDeleted) {
        return AfriexUserState.BLOCKED;
    }
    if (flags.isDeactivated === false ||
        flags.isSecurityFlagged === false ||
        flags.isDeleted === false ||
        flags.isVerified) {
        return AfriexUserState.UNBLOCKED;
    }
    return AfriexUserState.NON_ACTION;
}
// The single source of truth for "is this member the organisation owner".
// Ownership is the meta.flags.isOwner flag, never the Admin role.
export const isBusinessOwner = (user) => user?.meta?.flags?.isOwner === true;
//# sourceMappingURL=businessFlagUtils.js.map